import { createContext, Fragment, useContext, useReducer, useRef } from "react"
import { ModalReducer } from "./reducer"

import modalStyle from "./modal.module.css"


const ModalContext = createContext()

export default function ModalProvider({children}) {

    const ref = useRef()

    const [Component, dispatch] = useReducer(ModalReducer, <Fragment></Fragment>)

    function modal_open(props) {
        dispatch(props)

        ref.current.style.display = 'flex'
    }

    function modal_close() {
        ref.current.style.display = 'none'
    }

    return(
        <ModalContext.Provider
            value={{
                modal_open,
                modal_close
            }}
        >
            {children}

            <div
                ref={ref}
                className={modalStyle['wrap']}
            >
                <div className={modalStyle['back']}></div>

                <div className={modalStyle['content']}>
                    {Component}
                </div>
            </div>
        </ModalContext.Provider>
    )
}

export function useModal() {
    const context = useContext(ModalContext)

    return context
}